module.exports = __webpack_public_path__ + "./docs/img/icon-error_list.22dedf03bb614c493f811dd8b66e8d52.svg";